<template>
  <div class="accountNew tableloding">
    <!-- <span style="color:red;">{{$store.state.user.secret}}</span> -->
    <!-- <span style="color:red;">Query :{{$route.query}}</span> -->
    <!-- <div class="accounttop">
      <div class="accountname">{{$t('account.uselists')}}</div>
    </div> -->
    <!-- <span>groupIdClick：{{groupIdClick}}</span> -->
    <div class="section">
      <div class="search" v-if="$store.state.user.groupIsShow == 0">
        <div>
          <!-- 类型 -->
          <span class="search-label">{{ $t('account.role') }}</span>
          <el-select v-model="search.role" clearable @change="getAccountList(true)"
            :placeholder="$t('header.pleaseSelect')" popper-class="select-search-recharge" class="selectClearNew">
            <el-option v-for="(value, key) in roleOptions" :key="key" :value="key" :label="value.name"></el-option>
            <el-option v-if="$store.state.user.riyueyuanPermissionMark&&$store.state.user.role==1" :label="this.$t('account.riyueyuan_SonAdmin')" value="100"></el-option>
            <!-- <el-option v-if="$store.state.user.riyueyuanPermissionMark&&$store.state.user.role==1" :label="this.$t('account.riyueyuan_lineSonAdmin')" value="200"></el-option> -->
          </el-select>
          <!-- 活跃 -->
          <span class="search-label">{{ $t('account.activeStatus') }}</span>
          <el-select v-model="search.active" clearable @change="getAccountList(true)"
            :placeholder="$t('header.pleaseSelect')" popper-class="select-search-recharge" class="selectClearNew">
            <el-option v-for="(value, key) in searchOptions.activeStatus" :key="key" :value="key"
              :label="value.label"></el-option>
          </el-select>
          <!-- 状态 -->
          <span class="search-label">{{ $t('account.accountStatus') }}</span>
          <el-select v-model="search.enable" clearable @change="getAccountList(true)"
            :placeholder="$t('header.pleaseSelect')" popper-class="select-search-recharge" class="selectClearNew">
            <el-option v-for="(value, key) in searchOptions.accountStatus" :key="key" :value="key"
              :label="value.label"></el-option>
          </el-select>
          <!-- 分组 -->
          <!-- <el-select
            v-model="search.groupid"
            clearable
            @change="getAccountList(true)"
            :placeholder="$t('account.accountGroup')"
              popper-class="select-search-recharge"
          >
            <el-option
              v-for="(item,index) in searchOptions.accountGroup"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select> -->
          <!-- 名称 -->
          <!-- <el-input
            v-model.trim="search.usr"
            @keyup.enter.native="getAccountList(true)"
            :placeholder="this.$t('account.accountName')"
            clearable
          ></el-input> -->
        </div>

        <div style="display:flex;justify-content:flex-end;align-items:center;">
          <!-- 搜索 -->
          <!-- <button class="button-solid button" @click="getAccountList(true)">
            <i class="el-icon-search"></i>
          </button> -->
          <!-- showSearch = true; -->
          <el-button class="button button-solid" @click.stop="showSearchBtn">
            <i class="el-icon-search"></i>
          </el-button>
          <!-- v-clickoutside="closeSearch2" -->
          <div class="search-alert" v-show="showSearch">
            <!-- :placeholder="this.$t('device.Sn_deviceName')" -->
            <!-- v-model="inputText" -->
            <!-- @input实时查询 -->
            <!-- @keyup.enter.native -->
            <div class="searchDiv">
               <el-input class="searchAll" ref="iptFocus" v-model.trim="search.usr" @keyup.enter.native="getAccountList(true)"
                 :placeholder="this.$t('account.placeholder1')" clearable>
                 <i slot="prefix" class="el-input__icon el-icon-search"></i>
               </el-input>
               <!-- 搜索 -->
               <span class="search-device" @click="getAccountList(true)">{{ $t('recharge.Search') }}</span>
               <!-- 取消 -->
               <span class="search-hide" @click="closeSearch">{{ $t('rate.cancel') }}</span>
             </div>
          </div>
          <!-- 创建账号 -->
          <!-- <button
            class="button-solid button button-create"
            @click="creatcount"
          >
            <i class="el-icon-circle-plus-outline el-icon--left"></i>{{$t('account.createAccount')}}
          </button> -->
          <button type="button" class="button-upload" @click="creatcount">
            {{ $t('account.createAccount') }}
            <i class="iconfont icon-biaogegongneng_xinjian"></i>
          </button>
          <!-- 关联业主 -->
          <!-- <button
            type="button"
            class="button-upload"
            @click="relatedOwner"
            style="border-left:1px solid #000"
          >
            {{$t('account.relatedOwner')}}
            <i class="iconfont icon-biaogegongneng_xinjian"></i>
          </button> -->
        </div>
      </div>
      <div class="search1" v-if="$store.state.user.groupIsShow == 1">
        <div class="search1-left">
          <!-- <div style="color:#fff;font-size:20px;">{{this.groupIdClick.groupNameClick}}</div> -->
          <div class="groupBox">
            <div class="groupEdit">{{ groupIdClick.groupNameClick || $t('role.all') }}</div>
            <!-- <el-input class="groupEdit" placeholder="请输入昵称" v-model="groupIdClick.groupNameClick" ></el-input> -->
          </div>
          <i @click="editGroup()" v-if="groupIdClick.groupIdClick" class="iconfont icon-bianji" style="cursor: pointer;"></i>
        </div>
        <el-button v-if="groupIdClick.groupIdClick" @click="delGroup()" type="text" class="operation"
          style="background-color:rgba(221,104,67,0.5);border:1px solid #DD6843;">
          <i class="iconfont icon-caozuo_shanchu"></i>
          <span class="icon-text1">{{ $t('group.deletegroup') }}</span>
        </el-button>
      </div>
      <el-table :data="accountList" border stripe height="100%" :row-style="{ height: 0 }" :cell-style="{ padding: 0 }"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" v-loading="loadingAccount"
        element-loading-spinner="el-icon-loading" class="tablemain tableloding">
        <!-- :empty-text="$t('message.nodata')" -->
        <el-table-column fixed :show-overflow-tooltip="true" min-width="120px;" :label="$t('account.accountName')">
          <template slot-scope="scope">
            <span class="redirect" @click="enterAccount(scope.row)">{{ scope.row.usr }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="role" :show-overflow-tooltip="true" min-width="150px;"
          :label="$t('account.role')">
          <template slot-scope="scope">
            <span  v-if="$store.state.user.riyueyuanPermissionMark&&scope.row.rid==1">{{$t('account.riyueyuan_SonAdmin')}}</span>
            <!-- <span  v-else-if="$store.state.user.riyueyuanPermissionMark&&scope.row.rid==2">{{$t('account.riyueyuan_lineSonAdmin')}}</span> -->
            <span  v-else>{{scope.row.role}}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" min-width="120px;" :label="$t('account.activeStatus')">
          <template slot-scope="scope">
            <span :class="scope.row.active.class">{{ scope.row.active.label }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" min-width="130px;" :label="$t('account.accountStatus')">
          <template slot-scope="scope">
            <span :class="scope.row.enable.class">{{ scope.row.enable.label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="collectors" min-width="110px;" :show-overflow-tooltip="true"
          :label="$t('account.dataloggerNum')"></el-table-column>
        <el-table-column prop="devices" min-width="90px;" :show-overflow-tooltip="true"
          :label="$t('account.deviceNum')"></el-table-column>
        <el-table-column min-width="130px;" :show-overflow-tooltip="true" :label="$t('account.mobile')">
          <template slot-scope="scope">
            <span :title="scope.row.mobile || '--'">{{ scope.row.mobile || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="130px;" :label="$t('account.email')" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :title="scope.row.email || '--'">{{ scope.row.email || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="100px;" :show-overflow-tooltip="true" :label="$t('account.nickname')">
          <template slot-scope="scope">
            <span :title="scope.row.qname || '--'">{{ scope.row.qname || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="110px;" :show-overflow-tooltip="true" :label="$t('account.accountGroup')">
          <template slot-scope="scope">
            <span :title="scope.row.group || '--'">{{ scope.row.group || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="130px;" :show-overflow-tooltip="true" :label="$t('account.dataogger_swith')">
          <template slot-scope="scope">
            <span :title="$t('account.disable')"  class="inactivedis"  v-if="scope.row.addCollectorPermissions !=undefined&&!scope.row.addCollectorPermissions">{{$t('account.disable')}}</span>
            <span :title="$t('account.enable')" class="active"  v-else>{{$t('account.enable')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="gts" min-width="180px;" :show-overflow-tooltip="true"
          :label="$t('account.createTime')"></el-table-column>
        <el-table-column min-width="180px;" :show-overflow-tooltip="true" :label="$t('account.lastLogin')">
          <template slot-scope="scope">
            <span :title="scope.row.lastLoginTs || '--'">{{ scope.row.lastLoginTs || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('account.operate')" width="275px" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" class="operation" :title="$t('account.Edit')" @click="editcount(scope.row)">
              <i class="iconfont icon-bianji"></i>
            </el-button>
            <el-button type="text" class="operation" v-show="scope.row.enable.class == 'active'"
              :title="$t('account.disable')" @click="disablecount(scope.row)">
              <i class="iconfont icon-caozuo_jinyong"></i>
            </el-button>
            <el-button type="text" class="operation" v-show="scope.row.enable.class == 'inactivedis'"
              :title="$t('account.enable')" @click="disablecount(scope.row)">
              <i class="iconfont icon-caozuo_qiyong"></i>
            </el-button>
            <el-button type="text" class="operation" :title="$t('account.group')" @click="groupcount(scope.row)">
              <i class="iconfont icon-caozuo_fenzu"></i>
            </el-button>
            <el-button type="text" class="operation" :title="$t('account.resetPwd')" @click="resetpwd(scope.row)">
              <i class="iconfont icon-caozuo_zhongzhimima"></i>
            </el-button>
            <el-button type="text" class="operation" :title="$t('account.Delete')" @click="detelegroup(scope.row)">
              <i class="iconfont icon-caozuo_shanchu"></i>
            </el-button>
            <el-button type="text" class="operation" :title="$t('account.ascription')"
            :class="{ 'operation1': scope.row.role != $t('account.plantOwner') }"
             :disabled="scope.row.role == $t('account.plantOwner') ? false : true"
            @click="bandingCount(scope.row)">
              <i class="iconfont icon-a-mingchengyonghushuxingshuangren1"></i>
            </el-button>
            <el-button type="text" class="operation" :title="$t('account.Distribution_collector')"
              :class="{ 'operation1': scope.row.role != $t('account.distributor') }"
              :disabled="scope.row.role == $t('account.distributor') ? false : true"
              @click="distributionDatalogger(scope.row)">
              <i class="iconfont icon-a-mingchengfenpeishucaiqiyangshidansexianxingtubiao"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tablebottom">
        <!-- 批量占位 -->
        <span class="" style="margin-left:16px;"></span>
        <el-pagination class="pagination" background @size-change="getAccountList(true)"
          @current-change="() => getAccountList()" :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]" :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper" :total="pagination.total" popper-class="select-page">
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
    <!-- 创建新账号 -->
    <!-- v-if="showCreatnewcountDialog" -->
    <account-dialog :title="$t('account.createAccount')" :visible.sync="showCreatnewcountDialog" width="550px"
      :class="{ 'showDialog': showCreatnewcountDialog, 'hideDialog': !showCreatnewcountDialog }" noFooter>
      <el-form ref="creatForm" :model="form" class="chuangjian grid" slot="content" :rules="creatRules">
        <el-form-item :label="$t('account.role1')" prop="role">
          <el-select v-model="form.role" :placeholder="$t('account.selectUserType')"
            popper-class="select-search-recharge" clearable>
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
            <!-- 普通用户0 -->
            <el-option :label="$t('account.powerStationOwner')" value="0"></el-option>
            <!-- 经销商2 -->
            <el-option :label="$t('account.distributor')" value="2"></el-option>
            <el-option v-if="$store.state.user.riyueyuanPermissionMark&&$store.state.user.role==1" :label="this.$t('account.riyueyuan_SonAdmin')" value="100"></el-option>
            <!-- <el-option v-if="$store.state.user.riyueyuanPermissionMark&&$store.state.user.role==1" :label="this.$t('account.riyueyuan_lineSonAdmin')" value="200"></el-option> -->
          </el-select>
        </el-form-item>

        <!-- 账号分组 -->
        <!-- :placeholder="$t('account.selectUserType')" -->
        <el-form-item :label="$t('account.accountGroup')" prop="id">
          <el-select v-model="form.id" placeholder="" popper-class="select-search-recharge">
            <el-option v-for="(item, index) in groupList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('account.accountName1')" prop="name">
          <el-input v-model.trim="form.name" clearable :placeholder="$t('account.accountName')" @clear="Bytecheck"
            @keyup.native="UserByte" @keyup.enter.native="$refs.creatqname.focus()">
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
          <div class="inputlo">
            <div :class="isError ? 'input_spans' : 'sucess'" v-show="!Byte">
              <span>{{ usrtip }}</span>
            </div>
            <div class="input_span" v-show="Byte">
              <span style="font-size: 12px;font-weight: bold;">{{ $t('signup.Byte_1') }}</span>
              <span style="margin-left:2px;font-size:12px;font-weight:bold;color:#f00;">{{ Bytes }}</span>
              <span style="font-size: 12px;font-weight: bold;margin-left: 2px;">{{ $t('signup.Byte_2') }}</span>
            </div>
            <!-- <span>{{usrtip}}</span> -->
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.nickname1')" prop="qname">
          <el-input v-model.trim="form.qname" :placeholder="$t('account.nickname')" clearable ref="creatqname"
            @keyup.enter.native="$refs.creatmobile.focus()">
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.mobile1')" prop="mobile">
          <el-input clearable type="text" v-model.trim="form.mobile" ref="creatmobile"
          @keyup.enter.native="$refs.createmail.focus()">
          </el-input>
          <div class="inputlo">
            <div :class="phoneError ? 'phone_span' : 'sucess'">
              <span>{{ phonetip }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.email1')" prop="email">
          <el-input clearable v-model.trim="form.email" auto-complete="off" ref="createmail"
          @keyup.enter.native="$refs.creatpwd.focus()">
          </el-input>
          <div class="inputlo">
            <div :class="emailError ? 'email_span' : 'sucess'">
              <span>{{ emailtip }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.password1')" prop="pwd">
          <el-input v-model.trim="form.pwd" :placeholder="$t('account.password')" clearable type="text" class="password"
            ref="creatpwd" @clear="pwdcheck" @input.native="Passwordlevel"
            @keyup.enter.native="$refs.creatconfPwd.focus()">
            <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
          </el-input>
          <div class="inputlo">
            <div :class="passpwdError ? 'pwd_span' : 'sucess'" v-show="!strength">
              <span>{{ pwdtip }}</span>
            </div>
            <div class="input_span" v-show="strength">
              <span style="font-size: 12px;font-weight: bold;">{{ $t('signup.qiangdu') }}</span>
              <span class="juxing" ref="Passwordlevel"></span>
              <span style="font-size: 12px;font-weight: bold;margin-left: 5px;">{{ count }}</span>
            </div>
            <!-- <span>{{usrtip}}</span> -->
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.confirmpassword1')" prop="confPwd">
          <el-input v-model.trim="form.confPwd" :placeholder="$t('account.confirmpassword')" clearable type="text"
            class="password" ref="creatconfPwd" @keyup.enter.native="$refs.createmail.focus()">
            <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
          </el-input>
          <div class="inputlo">
            <div :class="confpwdError ? 'confpwd_span' : 'sucess'">
              <span>{{ confpwdtip }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.Related_roles')" prop="roleId"  v-if="this.$store.state.user.role ==1&&(form.role ==2||form.role ==100||form.role ==200)" >
          <el-select v-model="form.roleId" :placeholder="$t('account.Ple_role1')" popper-class="select-search-recharge" clearable>
            <el-option v-for="(item, index) in DistRoleList" :key="index" :label="item.roleName"
              :value="item.roleId"></el-option>
          </el-select>
        </el-form-item>
        <div  v-if="this.$store.state.user.role ==1&&form.role ==2" style="max-width: 150px;word-break: break-all;">{{ $t('account.dataogger_swith') }}:</div>
        <div style="position: relative;margin-left: 20px;display: flex;align-items: center;"  v-if="this.$store.state.user.role ==1&&form.role ==2">
            <i class="el-icon-check" v-if="dataoggerSwithControl" 
            style="position: absolute;z-index: 1;left: 12px;top: 50%;margin-top: -7px;"></i>
             <el-switch class="eb-switch" v-model="dataoggerSwithControl" :width="50">
             </el-switch>
          <span class="help-label">{{ $t('account.dataogger_swithTip') }}</span>
        </div>
        <!-- Grid占位 -->
        <div></div>
        <div style="text-align:right;">
          <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
          <el-button type="button" class="btn btn-dark" @click="creatnewcount" :loading="createBtnLoading">{{ $t('account.submit') }}</el-button>
        </div>
      </el-form>
    </account-dialog>
    <!-- 创建新账号结果提示(成功) -->
    <!-- v-if="creatAccountSucVisible" -->
    <account-dialog :title="$t('account.createAccount')" :visible.sync="creatAccountSucVisible"
      :class="{ 'showDialog': creatAccountSucVisible, 'hideDialog': !creatAccountSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('account.createSuc') }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="creatAccountSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 创建新账号结果提示(失败) -->
    <!-- v-if="creatAccountFailVisible" -->
    <account-dialog :title="$t('account.createAccount')" :visible.sync="creatAccountFailVisible"
      :class="{ 'showDialog': creatAccountFailVisible, 'hideDialog': !creatAccountFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="creatAccountFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!--编辑用户 -->
    <!-- v-if="showEditcountDialog" -->
    <account-dialog :title="$t('account.editUser')" :visible.sync="showEditcountDialog" :width="'500px'"
      :class="{ 'showDialog': showEditcountDialog, 'hideDialog': !showEditcountDialog }" noFooter>
      <el-form ref="editForm" :model="usrDatas" :rules="editRules" slot="content" class="bianji grid"
        element-loading-spinner="el-icon-loading" v-loading="loadingeditcount">
        <el-form-item :label="$t('account.role1')">
          <!-- <el-input :value="usrDatas.role" auto-complete="off" disabled>
          </el-input> -->
          <el-input v-if="usrDatas.roleType == 2&&$store.state.user.riyueyuanPermissionMark&&usrDatas.rid ==1" :value="this.$t('account.riyueyuan_SonAdmin')" auto-complete="off" disabled></el-input>
          <!-- <el-input v-else-if="usrDatas.roleType == 2&&$store.state.user.riyueyuanPermissionMark&&usrDatas.rid ==2" :value="this.$t('account.riyueyuan_lineSonAdmin')" auto-complete="off" disabled></el-input> -->
          <el-input  v-else  :value="usrDatas.role" auto-complete="off" disabled>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.accountName1')">
          <el-input v-model="usrDatas.usr" auto-complete="off" disabled>
            <!-- <img slot="prefix" src="@/assets/img/nicheng.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.nickname1')">
          <el-input clearable v-model="usrDatas.qname" auto-complete="off">
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.mobile1')" prop="mobile">
          <el-input clearable type="text" v-model="usrDatas.mobile">
            <!-- <img slot="prefix" src="@/assets/img/shouji.png" style="width:13px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.email1')" prop="email">
          <el-input clearable v-model="usrDatas.email" auto-complete="off">
            <!-- <img slot="prefix" src="@/assets/img/youxiang.png" style="width:19px;height:14px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.Related_roles')" v-if="this.$store.state.user.role ==1&&params.roleType==2" prop="roleId">
          <el-select v-model="usrDatas.roleId" :placeholder="$t('account.Ple_role1')" popper-class="select-search-recharge" clearable>
            <el-option v-for="(item, index) in DistRoleList" :key="index" :label="item.roleName" :value="item.roleId"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="this.$store.state.user.role ==1&&params.roleType==2&&params.rid==0" style="max-width: 150px;word-break: break-all;">{{ $t('account.dataogger_swith') }}:</div>
        <div style="position: relative;margin-left: 20px;display: flex;align-items: center;" v-if="this.$store.state.user.role ==1&&params.roleType==2&&params.rid==0">
            <i class="el-icon-check" v-if="dataoggerSwithControl" 
            style="position: absolute;z-index: 1;left: 12px;top: 50%;margin-top: -7px;"></i>
             <el-switch class="eb-switch" v-model="dataoggerSwithControl" :width="50">
             </el-switch>
          <span class="help-label">{{ $t('account.dataogger_swithTip') }}</span>
        </div>
        <!-- Grid占位 -->
        <div></div>
        <div style="text-align:right;">
          <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
          <button type="button" class="btn btn-dark" @click="editoldcount">{{ $t('account.confirm') }}</button>
        </div>
      </el-form>
    </account-dialog>
    <!-- 编辑账号结果提示(成功) -->
    <!-- v-if="editAccountSucVisible" -->
    <account-dialog :title="$t('account.editAccount')" :visible.sync="editAccountSucVisible"
      :class="{ 'showDialog': editAccountSucVisible, 'hideDialog': !editAccountSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('account.modifiedsuccess') }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="editAccountSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 编辑账号结果提示(失败) -->
    <!-- v-if="editAccountFailVisible" -->
    <account-dialog :title="$t('account.editAccount')" :visible.sync="editAccountFailVisible"
      :class="{ 'showDialog': editAccountFailVisible, 'hideDialog': !editAccountFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="editAccountFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 用户启用禁用 -->
    <account-dialog-if :title="disAndEnTitle" :visible.sync="showdisablecountDialog" :width="'450px'"
      v-if="showdisablecountDialog" noFooter>
      <!-- 启用 -->
      <div
        v-if="this.params.enable.class=='active'? true : false"
        slot="content" class="content_tishi">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span class="contentdelete" style="width:100%;text-align:left;color:rgba(255, 62, 62, 1);">{{
            `${$t('account.confirmDisable')}` }}</span>
        </div>
        <!-- <div class="disablecontent">{{$t('account.confirmDisable')}}</div> -->
        <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;color:rgba(255, 255, 255, 0.7);">{{
            $t('account.afterDisable') }}</span>
        </div>
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" style="margin-right:10px;" @click="disableoldcount">{{
            $t('account.confirm') }}</button>
          <button type="button" class="btn btn-light" @click="closeDialog">{{ $t('account.cancel') }}</button>
        </div>
      </div>
      <!-- 禁用 -->
      <div
        v-if="this.params.enable.class == 'inactivedis' ? true : false"
        slot="content" class="content_tishi">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <div class="contentdelete" style="width:100%;text-align:left;color:rgba(73, 222, 255, 1);">
            {{ `${$t('account.confirmEnable')}` }}</div>
        </div>
        <!-- <div class="disablecontent">{{$t('account.confirmEnable')}}</div> -->
        <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;color:rgba(255, 255, 255, 0.7);">{{
            $t('account.afterEnable') }}</span>
        </div>
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" style="margin-right:10px;" @click="disableoldcount">{{
            $t('account.confirm') }}</button>
          <button type="button" class="btn btn-light" @click="closeDialog">{{ $t('account.cancel') }}</button>
        </div>
      </div>
    </account-dialog-if>
    <!-- 禁用/启用账号结果提示(成功) -->
    <!-- v-if="disableAccountSucVisible" -->
    <account-dialog :title="$t('account.accountStatus')" :visible.sync="disableAccountSucVisible"
      :class="{ 'showDialog': disableAccountSucVisible, 'hideDialog': !disableAccountSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <!-- <span class="showresulttext">{{$t('account.modifiedsuccess')}}</span> -->
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="disableAccountSucVisible = false;">{{ $t('datalogger.confirm')
            }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 禁用/启用账号结果提示(失败) -->
    <!-- v-if="disableAccountFailVisible" -->
    <account-dialog :title="$t('account.accountStatus')" :visible.sync="disableAccountFailVisible"
      :class="{ 'showDialog': disableAccountFailVisible, 'hideDialog': !disableAccountFailVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="disableAccountFailVisible = false;">{{ $t('datalogger.confirm')
            }}</button>
          </div>
        </div>
      </div>
    </account-dialog>

    <!-- 分组用户 -->
    <!-- v-if="showGroupcountDialog" -->
    <account-dialog :title="$t('account.group')" :visible.sync="showGroupcountDialog" :width="'50vh'"
      :class="{ 'showDialog': showGroupcountDialog, 'hideDialog': !showGroupcountDialog }" noFooter>
      <el-form slot="content" class="bianji grid" ref="groupform" :model="groupcountcontent" :rules="groupRules"
        element-loading-spinner="el-icon-loading" v-loading="loadingGroup">
        <el-form-item :label="$t('account.accountName1')">
          <el-input :value="groupcountcontent.usr" auto-complete="off" disabled>
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.group1')" prop="id">
          <el-select v-model="groupcountcontent.id" :placeholder="$t('account.chooseGroup')"
            popper-class="select-search-recharge">
            <!-- <img slot="prefix" src="@/assets/img/fenzu.png" style="width:18px;height:22px;" /> -->
            <el-option v-for="(item, index) in groupList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- Grid占位 -->
        <div></div>
        <div style="text-align:right;">
          <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
          <button type="button" class="btn btn-dark" @click="addgroupcount">{{ $t('account.confirm') }}</button>
        </div>
      </el-form>
    </account-dialog>
    <!-- 分组结果提示(成功) -->
    <!-- v-if="editToGroupSucVisible" -->
    <account-dialog :title="$t('account.editAccount')" :visible.sync="editToGroupSucVisible"
      :class="{ 'showDialog': editToGroupSucVisible, 'hideDialog': !editToGroupSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <!-- <span class="showresulttext">{{$t('account.modifiedsuccess')}}</span> -->
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="editToGroupSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 分组结果提示(失败) -->
    <!-- v-if="editToGroupFailVisible" -->
    <account-dialog :title="$t('account.editAccount')" :visible.sync="editToGroupFailVisible"
      :class="{ 'showDialog': editToGroupFailVisible, 'hideDialog': !editToGroupFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="editToGroupFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>

    <!-- 重置密码 -->
    <!-- v-if="showResetpwdDialog" -->
    <!-- :class="{'showDialog': showResetpwdDialog, 'hideDialog': !showResetpwdDialog}" -->
    <account-dialog-if :title="$t('account.resetPwd')" :visible.sync="showResetpwdDialog" :width="'500px'"
      v-if="showResetpwdDialog" noFooter>
      <el-form slot="content" class="chongzhi grid" ref="resetform" :model="resetform" :rules="resetRules">
        <el-form-item :label="$t('account.accountName1')" prop="usr">
          <el-input :value="resetform.usr" auto-complete="off" disabled>
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.newPwd1')" prop="newpwd">
          <el-input v-model.trim="resetform.newpwd" :placeholder="$t('account.newPwd')" type="text" class="password"
            clearable @clear="pwdcheck" @input.native="NewPasswordlevel" @keyup.enter.native="$refs.resetconfPwd.focus()">
            <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
          </el-input>
          <div class="inputlo">
            <div :class="passpwdError ? 'pwd_span' : 'sucess'" v-show="!strength">
              <span>{{ pwdtip }}</span>
            </div>
            <div class="input_span" v-show="strength">
              <span style="font-size: 12px;font-weight: bold;">{{ $t('signup.qiangdu') }}</span>
              <span class="juxing" ref="NewPasswordlevel"></span>
              <span style="font-size: 12px;font-weight: bold;margin-left: 5px;">{{ count }}</span>
            </div>
            <!-- <span>{{usrtip}}</span> -->
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.confirmpassword1')" prop="confPwd">
          <el-input v-model.trim="resetform.confPwd" :placeholder="$t('account.confirmpassword')" type="text"
            class="password" clearable ref="resetconfPwd" @keyup.enter.native="resetpwdold">
            <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
          </el-input>
          <div class="inputlo">
            <div :class="confpwdError ? 'confpwd_span' : 'sucess'">
              <span>{{ confpwdtip }}</span>
            </div>
          </div>
        </el-form-item>
        <!-- Grid占位 -->
        <div></div>
        <div style="text-align:right;">
          <button type="button" class="btn btn-dark" @click="resetpwdold">{{ $t('account.confirm') }}</button>
          <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
        </div>
      </el-form>
    </account-dialog-if>
    <!-- 重置密码结果提示(成功) -->
    <!-- v-if="resetPwdSucVisible" -->
    <account-dialog :title="$t('account.resetPwd')" :visible.sync="resetPwdSucVisible"
      :class="{ 'showDialog': resetPwdSucVisible, 'hideDialog': !resetPwdSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('account.resetPwdSuc') }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="resetPwdSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 重置密码结果提示(失败) -->
    <!-- v-if="resetPwdFailVisible" -->
    <account-dialog :title="$t('account.resetPwd')" :visible.sync="resetPwdFailVisible"
      :class="{ 'showDialog': resetPwdFailVisible, 'hideDialog': !resetPwdFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="resetPwdFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>

    <!-- 删除用户 去掉弹框的heard不加title=""和footer noFooter -->
    <!-- v-if="showDeletecountDialog" -->
    <account-dialog :title="$t('account.deleteUser')" :visible.sync="showDeletecountDialog" :width="'450px'"
      :class="{ 'showDialog': showDeletecountDialog, 'hideDialog': !showDeletecountDialog }" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span class="contentdelete" style="width:100%;text-align:left;">{{ $t('account.confirmDelete') }}</span>
        </div>
        <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;color:rgba(255, 255, 255, 0.7);">{{
            $t('account.notRecovered') }}</span>
        </div>
        <!-- {{$t('account.confirmDelete')}}</div> -->
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <el-button type="button" class="btn btn-dark" style="margin-right:10px;width:70px" @click="deleteoldcount" :loading="deleteBtnLoading">{{
            $t('account.confirm') }}</el-button>
          <el-button type="button" class="btn btn-light" style="width:70px" @click="closeDialog">{{ $t('account.cancel') }}</el-button>
        </div>
      </div>
    </account-dialog>
    <!-- 删除账号结果提示(成功) -->
    <!-- v-if="delAccountSucVisible" -->
    <account-dialog :title="$t('account.deleteUser')" :visible.sync="delAccountSucVisible"
      :class="{ 'showDialog': delAccountSucVisible, 'hideDialog': !delAccountSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('account.Deletesuccessfully') }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="delAccountSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 删除账号结果提示(失败) -->
    <!-- v-if="delAccountFailVisible" -->
    <account-dialog :title="$t('account.deleteUser')" :visible.sync="delAccountFailVisible"
      :class="{ 'showDialog': delAccountFailVisible, 'hideDialog': !delAccountFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="delAccountFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!--编辑分组弹窗 -->
    <!-- v-if="showEditDialog" -->
    <account-dialog :title="$t('group.Edit_groups')" :visible.sync="showEditDialog" :width="'450px'"
      :class="{ 'showDialog': showEditDialog, 'hideDialog': !showEditDialog }" noFooter>
      <el-form ref="editGroupsForm" :model="groupsDatas" label-position="right" slot="content" :rules="Rules"
        class="grid">
        <el-form-item :label="$t('group.Group_name1')" prop="groupName">
          <el-input type="text" v-model.trim="groupsDatas.groupName" autocomplete="off">
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('group.note1')" prop="desc">
          <el-input type="text" v-model.trim="groupsDatas.desc" autocomplete="off">
            <!-- <img slot="prefix" src="@/assets/img/fenzu.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>

        <!-- Grid占位 -->
        <div></div>
        <div style="text-align:right;">
          <!-- <button class="button-hollow" @click="showEditDialog = false">{{$t('group.cancel')}}</button> -->
          <button type="button" class="btn btn-dark" @click="submitEditGroup">{{ $t('group.confirm') }}</button>
        </div>
      </el-form>
    </account-dialog>
    <!-- 编辑分组结果提示(成功) -->
    <!-- v-if="editGroupSucVisible" -->
    <account-dialog :title="$t('group.Edit_groups')" :visible.sync="editGroupSucVisible"
      :class="{ 'showDialog': editGroupSucVisible, 'hideDialog': !editGroupSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('group.editsuc') }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="editGroupSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 编辑分组结果提示(失败) -->
    <!-- v-if="editGroupFailVisible" -->
    <account-dialog :title="$t('group.Edit_groups')" :visible.sync="editGroupFailVisible"
      :class="{ 'showDialog': editGroupFailVisible, 'hideDialog': !editGroupFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="editGroupFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 删除分组弹窗：去掉弹框的heard不加title=""和footer noFooter -->
    <!-- v-if="showDeleteDialog" -->
    <account-dialog :title="$t('group.deletegroup')" :visible.sync="showDeleteDialog" :width="'450px'"
      :class="{ 'showDialog': showDeleteDialog, 'hideDialog': !showDeleteDialog }" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span class="contentdelete" style="width:100%;text-align:left;">{{ $t('group.deleteConfirm') }}</span>
        </div>
        <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;">
            {{ $t('account.notRecovered') }}
          </span>
        </div>
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" style="margin-right:10px;" @click="submitDelGroup">{{
            $t('group.confirm') }}</button>
          <button type="button" class="btn btn-light" @click="showDeleteDialog = false;">{{ $t('group.cancel') }}</button>
        </div>
      </div>
    </account-dialog>
    <!-- 删除分组结果提示(成功) -->
    <!-- v-if="delGroupSucVisible" -->
    <account-dialog :title="$t('group.deletegroup')" :visible.sync="delGroupSucVisible"
      :class="{ 'showDialog': delGroupSucVisible, 'hideDialog': !delGroupSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('group.deletesuc') }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="delGroupSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 删除分组结果提示(失败) -->
    <!-- v-if="delGroupFailVisible" -->
    <account-dialog :title="$t('group.deletegroup')" :visible.sync="delGroupFailVisible"
      :class="{ 'showDialog': delGroupFailVisible, 'hideDialog': !delGroupFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="delGroupFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!--归属绑定用户 -->
    <!-- v-if="showBandingDialog" -->
    <account-dialog :title="$t('account.ascription')" :visible.sync="showBandingDialog" :width="'450px'"
      :class="{ 'showDialog': showBandingDialog, 'hideDialog': !showBandingDialog }" noFooter>
      <el-form :model="adminDatas" slot="content" class="bianji grid"
        element-loading-spinner="el-icon-loading" v-loading="loadingBelong">
        <el-form-item :label="$t('account.admin')">
          <el-select v-model="adminDatas.usr" default-first-option filterable
            popper-class="select-search-recharge" class="adminDatas" clearable>
            <el-option v-for="(item, index) in adminData" :key="index" :value="item.uid" :label="item.usr">

            </el-option>
          </el-select>
          <!-- <el-input :value="usrDatas.role" auto-complete="off" >
          </el-input> -->
        </el-form-item>
        <!-- Grid占位 -->
        <div></div>
        <div style="text-align:right;">
          <button type="button" class="btn btn-dark" @click="bangdingoldcount">{{ $t('account.confirm') }}</button>
        </div>
      </el-form>
    </account-dialog>
    <!--归属结果提示(成功) -->
    <!-- v-if="editAccountSucVisible" -->
    <account-dialog :title="$t('account.ascription_result')" :visible.sync="bandingAccountSucVisible"
      :class="{ 'showDialog': bandingAccountSucVisible, 'hideDialog': !bandingAccountSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('account.ascriptionSuccess') }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="bandingAccountSucVisible = false;">{{ $t('datalogger.confirm')
            }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!--归属结果提示(失败) -->
    <!-- v-if="editAccountFailVisible" -->
    <account-dialog :title="$t('account.ascription_result')" :visible.sync="bandingAccountFailVisible"
      :class="{ 'showDialog': bandingAccountFailVisible, 'hideDialog': !bandingAccountFailVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="bandingAccountFailVisible = false;">{{ $t('datalogger.confirm')
            }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 分配数采器 分配的对象为经销商或者下级经销商 -->
    <account-dialog :title="$t('account.Distribution_collector')" :tooltipContent="$t('account.tooltipContent')"
      :visible.sync="showDistributionDialog" :width="'700px'"
      :class="{ 'showDialog': showDistributionDialog, 'hideDialog': !showDistributionDialog }" noFooter>
      <div slot="content">
        <el-form ref="distributionRef" :rules="distributionRulesForm" :model="distributionForm" class="bianji grid"
          element-loading-spinner="el-icon-loading">
          <!-- :label="`${$t('account.relatedSuccess')}:`" -->
          <el-form-item :label="`${$t('account.distributor')}：`">
            <el-input type="text" v-model.trim="distributionForm.usr" disabled>
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('account.Distribution_method')}：`">
            <el-radio-group v-model="distributionForm.type" v-removeAriaHidden @input="clearValidationVal">
              <el-radio :label="0">{{ $t('account.Batch_allocation') }}</el-radio>
              <el-radio :label="1">{{ $t('account.Individual_allocation') }}</el-radio>
              <el-radio :label="2">{{ $t('account.Order_allocation') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="`${$t('firmware.Upload1')}：`" prop="file" v-if="distributionForm.type == 0">
            <div class="upload-contents">
              <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                <i class="iconfont icon-shangchuan1"></i>
              </button>
              <div class="upload-tip">{{ `${$t('firmware.Upload1')} (${$t('firmware.limit1')})` }}</div>
              <span v-if="distributionFile">{{ distributionFile.name }}</span>
              <input type="file" class="upload-input" ref="fileUploader" accept=".xlsx"
                @change="uploadfile($event)" />
            </div>
          </el-form-item>
          <el-form-item :label="`${$t('account.PNNum')}：`" prop="pn" v-if="distributionForm.type == 1">
            <el-input type="text" v-model.trim="distributionForm.pn">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('account.order_number')}：`" prop="order" v-if="distributionForm.type == 2">
            <el-input type="text" v-model.trim="distributionForm.order">
            </el-input>
          </el-form-item>
        </el-form>
        <div style="margin-top: 15px;" v-if="distributionForm.type == 0">
          <div style="font-size:16px;color:#DD6843;">{{ $t('firmware.limit2') }}</div>
          <img src="@/assets/img/importPnExample.png" style="margin-top: 10px;" alt="">
        </div>
        <div style="text-align:right;">
          <button type="button" class="btn btn-dark" @click="distributionSub">{{ $t('account.confirm') }}</button>
        </div>
      </div>
    </account-dialog>
    <!-- 分配采器结果提示(成功)-->
    <account-dialog :title="$t('account.Allocation_result')" :visible.sync="dataloggerDistributionSucVisible"
      :class="{ 'showDialog': dataloggerDistributionSucVisible, 'hideDialog': !dataloggerDistributionSucVisible }"
      width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('account.Assigned_successfully') }}</span>
          <div class="showoperate">
            <!-- 继续添加 -->
            <button type="button" class="btn btn-light" style="margin-right:10px;"
              @click="dataloggerDistributionSucVisible = false; distributionDatalogger(params, 'again')">{{
                $t('datalogger.continueAdding') }}</button>
            <!-- 确定 -->
            <button type="button" class="btn btn-dark"
              @click="dataloggerDistributionSucVisible = false; getAccountList()">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 分配数采器结果提示(失败) -->
    <!-- v-if="dataloggerEditFailVisible" -->
    <account-dialog :title="$t('account.Allocation_result')" :visible.sync="dataloggerDistributionFailVisible"
      :class="{ 'showDialog': dataloggerDistributionFailVisible, 'hideDialog': !dataloggerDistributionFailVisible }"
      width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <div class="showoperate">
            <!-- 暂不添加 -->
            <button type="button" class="btn btn-light" style="margin-right:10px;"
              @click="dataloggerDistributionFailVisible = false;">{{ $t('datalogger.nowNoAdd') }}</button>
            <!-- 重新添加 -->
            <button type="button" class="btn btn-dark"
              @click="dataloggerDistributionFailVisible = false; distributionDatalogger(params, 'again')">{{
                $t('datalogger.reAdd') }}</button>
          </div>
        </div>
      </div>
    </account-dialog>
    <!-- 订单分配采集器核对确认 -->
    <!-- <account-dialog :title="$t('account.order_check')" :visible.sync="dataloggerOrderCheckVisible"
      :class="{ 'showDialog': dataloggerOrderCheckVisible, 'hideDialog': !dataloggerOrderCheckVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div style="font-size:16px;">
          {{ `${$t('account.Confirm_assignment')}'${distributionForm.usr}'${$t('account.IsIt')}？` }}</div>
        <div style="text-align:right;margin-top:15px">
          <button type="button" class="btn btn-dark" style="margin-right:10px;" @click="submitOrderCheck">{{
            $t('group.confirm') }}</button>
          <button type="button" class="btn btn-light" @click="dataloggerOrderCheckVisible = false;">{{ $t('group.cancel')
          }}</button>
        </div>
      </div>
    </account-dialog> -->
    <account-dialog :title="$t('account.order_check')" :visible.sync="dataloggerOrderCheckVisible"
      :class="{ 'showDialog': dataloggerOrderCheckVisible, 'hideDialog': !dataloggerOrderCheckVisible }" width="500px"
      noFooter>
      <div slot="content">
        <div style="font-size:16px;">
          {{ `${$t('account.Ple_orderNum2')}${this.dataloggerNumbor}${$t('account.Ple_orderNum3')}[${distributionForm.usr}]${$t('account.IsIt')}？` }}</div>
        <div style="text-align:right;margin-top:15px">
          <button type="button" class="btn btn-dark" style="margin-right:10px;" @click="submitOrderCheck">{{
            $t('group.confirm') }}</button>
          <button type="button" class="btn btn-light" @click="dataloggerOrderCheckVisible = false;">{{ $t('group.cancel')
          }}</button>
        </div>
      </div>
    </account-dialog>
  </div>
</template>
<script>
import accountDialog from "@/components/dialognew";
import accountDialogIf from "@/components/dialognew/flowIndex";
import encryption from "@/assets/js/encryption";
import cookie from "@/assets/js/cookie";
import { mapGetters } from 'vuex';
export default {
  components: {
    accountDialog,
    accountDialogIf,
  },
  data () {
    var validateusr = (rule, value, callback) => {
      var ref = /^\S{1,31}[a-zA-Z0-9_一-龥]$/;
      if (!value) {
        callback(new Error(""));
        this.usrtip = this.$t("message.uname_is_required");
        this.isError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.usrtip = this.$t("signup.usrformat");
        this.isError = true;
      } else {
        callback();
      }
    };
    var validatepwd = (rule, value, callback) => {
      var ref = /^[\w]{6,32}$/;
      if (!value) {
        callback(new Error(""));
        this.pwdtip = this.$t("message.pwd_is_required");
        this.passpwdError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.pwdtip = this.$t("signup.pwdformat");
        this.passpwdError = true;
      } else {
        callback();
      }
    };
    //新建账号的密码确认
    var validateconfPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdAgain");
        this.confpwdError = true;
      } else if (value !== this.form.pwd) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdNotsame");
        this.confpwdError = true;
      } else {
        this.confpwdtip = "";
        callback();
      }
    };
    //重置密码的密码确认
    var validateconfNewpwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdAgain");
        this.confpwdError = true;
      } else if (value !== this.resetform.newpwd) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdNotsame");
        this.confpwdError = true;
      } else {
        this.confpwdtip = "";
        callback();
      }
    };
    var validateemail = (rule, value, callback) => {
      var ref = /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)?@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      // if (!value) {
      //   callback(new Error(""));
      //   this.emailtip = this.$t("message.email_is_required");
      //   this.emailError = true;
      // } else 
      if (value&&!ref.test(value)) {
        callback(new Error(""));
        this.emailtip = this.$t("message.email_info");
        this.emailError = true;
      } else {
        this.emailtip = "";
        callback();
      }
    };
    var validatephone = (rule, value, callback) => {
      var ref = /^\d{6,32}$/;
      // if (!value) {
      //   callback(new Error(""));
      //   this.phonetip = this.$t("message.mobile_is_required");
      //   this.phoneError = true;
      // } else 
      if (value&&!ref.test(value)) {
        callback(new Error(""));
        this.phonetip = this.$t("signup.mobileformat");
        this.phoneError = true;
      } else {
        this.phonetip = " ";
        callback();
      }
    };
    const validatefile = (rule, value, callback) => {
      let suffix = this.distributionFile ? this.distributionFile.name.split(".").slice(-1)[0] : "";
      if (this.distributionFile === "" || this.distributionFile === undefined) {
        callback(new Error(this.$t("firmware.UploadTitle")));
      } else if (suffix !== "xlsx" && suffix !== "xls") {
        callback(new Error(this.$t("account.limitFormat")));
      } else {
        callback();
      }
    };
    return {
      // 判断是否有权限，之前的经销商不存在权限
      disPermissionsLogo:sessionStorage.getItem("disPermissionsLogo")?JSON.parse(sessionStorage.getItem("disPermissionsLogo")):false,
      // 页面权限集合
      btnList: sessionStorage.getItem("buttonArr")?JSON.parse(sessionStorage.getItem("buttonArr")):[],
      DistRoleList: [],
      dataoggerSwithControl: true,
      OrderNumbor:0,
      dataloggerNumbor:0,
      dataloggerOrderCheckVisible: false,
      dataloggerTipMsg: "",
      dataloggerDistributionFailVisible: false,
      dataloggerDistributionSucVisible: false,
      distributionFile: "",
      distributionForm: {
        uid: "",
        usr: "",
        type: 0,
        pn: "",
        order: "",
      },
      distributionRulesForm: {
        pn: [
          {
            required: true,
            message: this.$t("datalogger.Ple_PN"),
            trigger: "blur"
          }
        ],
        order: [
          {
            required: true,
            message: this.$t("account.Ple_orderNum"),
            trigger: "blur"
          }
        ],
        file: [
          { required: true, validator: validatefile, trigger: "change" }
        ],
      },
      showDistributionDialog: false,//分配数采器弹框
      groupListArr: [],//所有分组集合
      //所有下属管理员
      adminData: [],
      // 删除分组成功提示弹窗
      delGroupSucVisible: false,
      // 删除分组失败提示弹窗
      delGroupFailVisible: false,
      // 侧栏删除分组弹窗
      showDeleteDialog: false,
      groupsDatas: {
        groupName: "",
        desc: "",
        id: ""
      },
      Rules: {
        groupName: [
          {
            required: true,
            message: this.$t("group.entername"),
            trigger: "blur"
          }
        ]
      },
      // 编辑分组弹窗
      showEditDialog: false,
      // 编辑分组成功提示弹窗
      editGroupSucVisible: false,
      // 编辑分组失败提示弹窗
      editGroupFailVisible: false,
      emptyText: false,//默认不显示无数据
      personActive: false,
      personActives: '',
      personInactive: false,
      personInactives: '',
      confpwdError: false,
      isError: false,
      emailError: false,
      passpwdError: false,
      phoneError: false,
      Bytes: "",
      count: "",
      Byte: false,
      usrtip: '',
      pwdtip: '',
      emailtip: '',
      phonetip: '',
      confpwdtip: '',
      // usrtip: this.$t("signup.usr"),
      // pwdtip: this.$t("signup.pwd"),
      // emailtip: this.$t("signup.email_form"),
      // phonetip: this.$t("signup.phone_form"),
      // confpwdtip: this.$t("signup.confirm_pl"),
      strength: false,
      // 操作返回提示
      deviceTipMsg: "",
      //创建账号弹窗
      showCreatnewcountDialog: false,
      // 创建账号成功提示弹窗
      creatAccountSucVisible: false,
      // 创建账号失败提示弹窗
      creatAccountFailVisible: false,
      // 打开编辑用户信息弹框
      showEditcountDialog: false,
      // 编辑账号成功提示弹窗
      editAccountSucVisible: false,
      // 编辑账号失败提示弹窗
      editAccountFailVisible: false,
      // 打开分组弹框
      showGroupcountDialog: false,
      // 分组成功提示弹窗
      editToGroupSucVisible: false,
      // 分组失败提示弹窗
      editToGroupFailVisible: false,
      // 打开禁用弹框
      showdisablecountDialog: false,
      // 禁用账号成功提示弹窗
      disableAccountSucVisible: false,
      // 禁用账号失败提示弹窗
      disableAccountFailVisible: false,
      // 打开重置密码弹框 
      showResetpwdDialog: false,
      // 重置密码成功提示弹窗
      resetPwdSucVisible: false,
      // 重置密码失败提示弹窗
      resetPwdFailVisible: false,
      // 打开删除账号弹框
      showDeletecountDialog: false,
      // 删除账号成功提示弹窗
      delAccountSucVisible: false,
      // 删除账号失败提示弹窗
      delAccountFailVisible: false,
      // 打开编辑用户信息弹框
      showBandingDialog: false,
      // 编辑账号成功提示弹窗
      bandingAccountSucVisible: false,
      // 编辑账号失败提示弹窗
      bandingAccountFailVisible: false,
      search: {
        role: null,
        active: null,
        enable: null,
        groupid: null,
        usr: null
      },
      // 账号角色
      roleOptions: {
        0: {
          name: this.$t("role.plantOwner"),
          group: "general"
        },
        2: {
          name: this.$t("role.distributor"),
          group: "admin"
        },
      },
      searchOptions: {
        // 活跃状态
        activeStatus: {
          true: {
            label: this.$t("statistic.active"),
            class: "active"
          },
          false: {
            label: this.$t("statistic.inactive"),
            class: "inactive"
          },
        },
        // 用户状态
        accountStatus: {
          true: {
            label: this.$t("account.enable"),
            class: "active"
          },
          false: {
            label: this.$t("account.disable"),
            class: "inactivedis"
          },
        },
        // // 用户分组
        // accountGroup: []
      },
      accountList: [],
      loadingAccount: false,
      loadingeditcount: false,
      loadingGroup: false,
      loadingBelong: false,
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      }, // 分页数据
      usrDatas: {
        mobile: "",
        qname: "",
        usr: "",
        email: "",
        role: "",
        roleId: ""
      }, //编辑账号里面的信息
      adminDatas: {
        usr: "",
        pid: "",
      }, //归属业主信息
      groupcountcontent: {
        usr: "",
        id: ""
      }, //分组
      params: "",
      group: [], //放置分组id和名称的盒子
      midgroup: [], //放置分组id和名称的盒子
      // 分组集合
      groupList: [],
      vcode: "",
      //创建新帐号
      form: {
        mobile: "",
        qname: "",
        name: "",
        email: "",
        // 角色(默认普通用户)
        role: "0",
        pwd: "",
        confPwd: "",
        // 账号分组
        group: [],
        // 分组ID(默认首个)
        // id: "5c8776f1954d2b312245ba08",
        id: "",
        roleId: "",
      },
      //重置密码
      resetform: {
        usr: "",
        newpwd: "",
        confPwd: ""
      },
      creatRules: {
        // 增 role和group
        role: [{ required: true, trigger: "blur" }],
        // id: [{ required: true, trigger: "blur" }],
        name: [{ required: true, validator: validateusr, trigger: "change" }],
        pwd: [{ required: true, validator: validatepwd, trigger: "change" }],
        confPwd: [
          { required: true, validator: validateconfPwd, trigger: "change" }
        ],
        email: [
          {validator: validateemail, trigger: "change" },
          // {
          //   pattern: /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)?@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
          //   message: this.$t("message.email_info"),
          //   trigger: "change"
          // }
        ],
        mobile: [
          { validator: validatephone, trigger: "change" },
          // {
          //   min: 6,
          //   max: 32,
          //   message: this.$t("message.length6_32"),
          //   trigger: "change"
          // }
        ]
      },
      editRules: {
        email: [
          // {
          //   required: true,
          //   message: this.$t("message.email_is_required"),
          //   trigger: "blur"
          // },
          {
            pattern: /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)?@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: this.$t("message.email_info"),
            trigger: "blur"
          }
        ],
        mobile: [
          // {
          //   required: true,
          //   message: this.$t("message.mobile_is_required"),
          //   trigger: "blur"
          // },
          {
            pattern: /^\d{6,32}$/,
            message: this.$t("signup.mobileformat"),
            trigger: "blur"
          }
        ]
      },
      resetRules: {
        usr: [
          {
            required: true,
            message: this.$t("message.uname_is_required"),
            trigger: "blur"
          }
        ],
        newpwd: [{ required: true, validator: validatepwd, trigger: "change" }],
        // 确认密码
        confPwd: [
          { required: true, validator: validateconfNewpwd, trigger: "change" }
        ]
      },
      groupRules: {
        id: [
          {
            required: true,
            message: this.$t("message.id_is_required"),
            trigger: "blur"
          }
        ],
      },
      // 搜索弹出
      showSearch: false,

      //创建账号按钮loading
      createBtnLoading: false,
      //删除按钮loading
      deleteBtnLoading: false,
      //移出分组
      removeGroudID: "",
    };
  },
  created () {
    // 解析通过路由传入的搜索条件
    let { role = null, active = null } = this.$route.query;
    this.search.role = role;
    this.search.active = active;
    // this.queryAccountGroup();
    this.getVcode();
    // 获取分组数据 =====
    this.getGroupData();
    // 获取权限角色，厂家创建经销商时
    this.getDistRoleList();
  },
  mounted(){
    // console.log(this.$store.state.user.riyueyuanPermissionMark,"this.$store.state.user.riyueyuanPermissionMark")
    if(this.groupIsShow.groupIsShow==0){
      this.getAccountList();
    }else if(this.groupIsShow.groupIsShow==1){
      this.$request.get("queryAccountGroup").then(res => {
        if (res.err != 0||res.dat.group.length==0) {
          this.getAccountList();
        }
        // else{
        //   this.getAccountList();
        // }
      });
    }
  },
  computed: {
    // 用户禁启用标题
    disAndEnTitle () {
      let aim = this.params.enable.class;
      let res;
      switch (aim) {
        // 已启用系列
        case "active":
          res = this.$t("account.disable");
          // res = "禁用用户"
          break;
        // 已禁用系列
        case "inactivedis":
          res = this.$t("account.enable");
          // res = "启用用户"
          break;
        // 默认
        default:
          res = ""
          break;
      }
      return res;
    },
    // [点击分组ID]
    ...mapGetters({
      groupIdClick: 'getGroupIdClick',
      groupIsShow: 'getGroupIsShow',
    }),
  },
  watch: {
    // 响应更新电站列表事件(账号列表)
    "$store.state.event.updateAccountList" (val) {
      if (val) {
        this.getAccountList();
        this.$store.state.event.updateAccountList = false;
      }
    },
    // 账号管理左侧创建用户更新右侧用户列表
    "$store.state.event.updateUsrSList" (val) {
      if (val) {
        this.getAccountList();
        this.$store.state.event.updateUsrSList = false;
      }
    },
    // [点击分组ID]
    groupIdClick: {
      handler (val) {
        // 请求该分组的用户列表
        Object.assign(this.$data.search,this.$options.data.call(this).search)
        this.search.groupid = val.groupIdClick;
        this.getAccountList();
        // console.log("1111112222222233333333333333")
      },
      deep: true
    },
  },
  beforeDestroy(){
  },
  methods: {
    // 删除分组弹窗
    delGroup () {
      if(this.disPermissionsLogo&&!this.btnList.includes('delete_group')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.showDeleteDialog = true;
    },
    // 删除分组提交
    submitDelGroup () {
      this.$request.getDEVMicroservices(`/ppr/web/iotSysUserGroup/auth/delete/${this.groupIdClick.groupIdClick}`).then(res => {
        if (res.code == 0) {
          // this.$message.success(this.$t("group.deletesuc"));
          this.showDeleteDialog = false;
          this.delGroupSucVisible = true;
          this.getGroupData();
          this.search.groupid = this.groupIdClick.groupIdClick = '';
          this.getAccountList();
          this.$store.state.event.updateAccountList = true
          this.groupIdClick.groupNameClick = ""
        } else {
          // this.$message.error(this.$t(`errCode.${res.err}`));
          this.deviceTipMsg = res.message;
          this.delGroupFailVisible = true;
        }

      });
    },
    // 编辑分组弹窗
    editGroup () {
      console.log(this.groupIdClick,'this.groupListArr');
      
      if(this.disPermissionsLogo&&!this.btnList.includes('edit_group')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.$refs.editGroupsForm.clearValidate();
      // let params = {
      //   groupId: this.groupIdClick.groupIdClick,
      //   page:1,
      //   pageSize:50,
      // }
      this.$request.getDEVMicroservices("/ppr/web/iotSysUserGroup/auth/getList").then(res => {
        if (res.code == 0) {
          this.groupListArr = res.data;
          this.groupListArr = this.groupListArr.filter(
            item => item.id == this.groupIdClick.groupIdClick
          );
          this.groupsDatas.desc = this.groupListArr[0].remarks
          this.groupsDatas.groupName = this.groupListArr[0].groupName
        } else {
          this.groupListArr = [];
        }
       
      });
       this.showEditDialog = true;
    },
    // 编辑分组提交
    submitEditGroup () {
      this.$refs.editGroupsForm.validate(valid => {
        if (!valid) return false;
        this.$request
          .postDEVMicroservices("/ppr/web/iotSysUserGroup/auth/update", {
            id: this.groupIdClick.groupIdClick,
            remarks: this.groupsDatas.desc,
            groupName: this.groupsDatas.groupName
          })
          .then(res => {
            if (res.code == 0) {
              // this.$message.success(this.$t("group.editsuc"));
              this.showEditDialog = false;
              this.editGroupSucVisible = true;

              // this.getAccountList();
              this.$store.state.event.updateAccountList = true
              this.groupIdClick.groupNameClick = this.groupsDatas.groupName;
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = res.message;
              this.editGroupFailVisible = true;
            }
            setTimeout(() => {
              this.getGroupData();
              this.getAccountList();
            }, 500);
          });
      });
    },
    getGroupData () {
      this.midgroup = [];
      this.loadingGroup = true;
      this.$request.getDEVMicroservices("/ppr/web/iotSysUserGroup/auth/getList").then(res => {
        if (res.code == 0) {
          res.data.forEach(item => {
            this.midgroup.push({
              label: item.groupName,
              value: item.id
            });
          });
          // 移出分组(创建时无，分组时有)
          // let arr = { label: this.$t("account.deletegroup"), value: "0.0001" };
          // this.midgroup.unshift(arr);
          this.groupList = this.midgroup;

          // 默认分组(首个)
          // this.$set(this.form, 'id', res.dat.group[0].id || '');
          this.loadingGroup = false;
        }
      });
    },
    Bytecheck () {
      this.Byte = false;
      this.usrtip = this.$t("message.uname_is_required");
    },
    pwdcheck () {
      this.strength = false;
      this.pwdtip = this.$t("message.pwd_is_required");
    },
    // emailcheck () { },
    // phonecheck () { },
    UserByte () {
      var usernameRegex = /^\S{1,31}[a-zA-Z0-9_一-龥]$/;
      if (usernameRegex.test(this.form.name)) {
        //用户格式正确的情况下
        this.Byte = true;
        this.Bytes = this.form.name.length;
      } else {
        this.Byte = false;
        // this.usrtip = this.$t('signup.usrformat')
      }
    },
    Passwordlevel () {
      var reg = /^[\w]{6,32}$/i; //判断密码格式是否正确
      var reg1 = /[a-zA-Z]/; //字母
      var reg2 = /\d/; //数字
      var reg3 = /_/; //下划线
      if (reg.test(this.form.pwd)) {
        //密码格式正确的情况下
        if (
          reg1.test(this.form.pwd) &&
          reg2.test(this.form.pwd) &&
          reg3.test(this.form.pwd)
        ) {
          //高级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#3CBD35";
          this.count = this.$t("signup.qiang");
        } else if (
          (reg1.test(this.form.pwd) && reg2.test(this.form.pwd)) ||
          (reg1.test(this.form.pwd) && reg3.test(this.form.pwd)) ||
          (reg2.test(this.form.pwd) && reg3.test(this.form.pwd))
        ) {
          //中级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FA9D1F";
          this.count = this.$t("signup.zhong");
        } else if (
          reg1.test(this.form.pwd) ||
          reg2.test(this.form.pwd) ||
          reg3.test(this.form.pwd)
        ) {
          //低级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FF0000";
          this.count = this.$t("signup.di");
        }
      } else {
        this.strength = false;
      }
    },
    NewPasswordlevel () {
      var reg = /^[\w]{6,32}$/i; //判断密码格式是否正确
      var reg1 = /[a-zA-Z]/; //字母
      var reg2 = /\d/; //数字
      var reg3 = /_/; //下划线
      if (reg.test(this.resetform.newpwd)) {
        //密码格式正确的情况下
        if (
          reg1.test(this.resetform.newpwd) &&
          reg2.test(this.resetform.newpwd) &&
          reg3.test(this.resetform.newpwd)
        ) {
          //高级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#3CBD35";
          this.count = this.$t("signup.qiang");
        } else if (
          (reg1.test(this.resetform.newpwd) &&
            reg2.test(this.resetform.newpwd)) ||
          (reg1.test(this.resetform.newpwd) &&
            reg3.test(this.resetform.newpwd)) ||
          (reg2.test(this.resetform.newpwd) && reg3.test(this.resetform.newpwd))
        ) {
          //中级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#FA9D1F";
          this.count = this.$t("signup.zhong");
        } else if (
          reg1.test(this.resetform.newpwd) ||
          reg2.test(this.resetform.newpwd) ||
          reg3.test(this.resetform.newpwd)
        ) {
          //低级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#FF0000";
          this.count = this.$t("signup.di");
        }
      } else {
        this.strength = false;
      }
    },
    // // 查询用户所有分组
    // queryAccountGroup () {
    //   this.$request.get("queryAccountGroup").then(res => {
    //     if (res.err === 0) {
    //       res.dat.group.forEach(item => {
    //         this.group.push({
    //           label: item.name,
    //           value: item.id
    //         });
    //       });
    //       this.searchOptions.accountGroup = this.group;
    //       // var All = {
    //       //   "label": this.$t("statistic.All"),
    //       //   "value": ""
    //       // }
    //       // this.searchOptions.accountGroup.push(All)
    //     }
    //   });
    // },
    // 查询用户列表
    getAccountList (reset) {
      // console.log("this.groupIdClick", this.groupIdClick);
      if (reset) this.pagination.currentPage = 1;
      if (this.groupIsShow.groupIsShow==0) {
        this.$store.commit("saveGroupIdClick", {
          groupIdClick: "",
          groupNameClick: ""
        });
      }
      // if(reset == personActive)
      let param
      if(this.search.role==100||this.search.role==200){
        param =  {
          ...this.search,
          rid:this.search.role==100?1:2,
          groupid: this.groupIdClick.groupIdClick,
          page: this.pagination.currentPage - 1,
          pagesize: this.pagination.pagesize,
          devtype:2304,
        };
        delete param.role;
      }else{
        param =  {
          ...this.search,
          // [增]分组ID取Store
          groupid: this.groupIdClick.groupIdClick,
          page: this.pagination.currentPage - 1,
          pagesize: this.pagination.pagesize,
          devtype:2304,
        };
      }
      if(this.groupIdClick.groupIdClick){
      this.loadingAccount = true;
        param = {
          ...param,
          groupId: this.groupIdClick.groupIdClick,
          pageSize: this.pagination.pagesize,
        };
      this.$request.getDEVMicroservices("/ppr/web/iotSysUserGroup/getGroupAndUser", param).then(res => {
        if (res.code === 0) {
          
          res.data.list.forEach(item => {
            // 新接口字段映射为旧结构：id→uid、account→usr、userName→qname、createTime→gts
            item.uid = item.id;
            item.usr = item.account;
            item.qname = item.userName;
            item.gts = item.createTime;
            item.email = item.userEmail;
            item.mobile = item.userPhone;
            // accountType对应role：accountType为3则对应0，其它不变
            item.role = item.accountType == 3 ? 0 : item.accountType;
            // status对应enable：0为启用
            item.enable = item.status == 0;
            if (item.source == null) item.source = 1;
            // 与旧分支保持一致：role翻译为名称，active/enable翻译为展示对象
            this.$set(item, "roleType", item.role);
            item.role = this.$filter.role(item.role).name;
            item.active = this.searchOptions.activeStatus[item.active];
            item.enable = this.searchOptions.accountStatus[item.enable];
          });
          this.accountList = res.data.list;
          this.pagination.total = res.data.total;

          // [存总数到Store]
          this.$store.commit('saveAccountTotal', {
            accountTotal: res.data.total
          })

        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.accountList = [];
          this.pagination.total = 0;
        }
        this.$store.state.event.sidebartabUsrGroup = false;
        this.loadingAccount = false;
      }).catch(() => {
        this.$store.state.event.sidebartabUsrGroup = false;
        this.loadingAccount = false;
      });
      }else{
      this.loadingAccount = true;
      this.$request.get("webQueryUsrEs", param).then(res => {
        if (res.err === 0) {
          res.dat.account.forEach(item => {
            this.$set(item, "roleType", item.role);
            item.role = this.$filter.role(item.role).name;
            item.active = this.searchOptions.activeStatus[item.active];
            item.enable = this.searchOptions.accountStatus[item.enable];
          });
          this.accountList = res.dat.account;
          this.pagination.total = res.dat.total;

          // [存总数到Store]
          this.$store.commit('saveAccountTotal', {
            accountTotal: res.dat.total
          })

        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.accountList = [];
          this.pagination.total = 0;
        }
        this.$store.state.event.sidebartabUsrGroup = false;
        this.loadingAccount = false;
      }).catch(() => {
        this.$store.state.event.sidebartabUsrGroup = false;
        this.loadingAccount = false;
      });
      }

    },
    //关闭对话框
    closeDialog () {
      this.showCreatnewcountDialog = false;
      this.showEditcountDialog = false;
      this.showdisablecountDialog = false;
      this.showGroupcountDialog = false;
      this.showResetpwdDialog = false;
      this.showDeletecountDialog = false;
    },
    //打开创建账号按钮
    creatcount () {
      if(this.disPermissionsLogo&&!this.btnList.includes('create_account')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.$refs.creatForm.resetFields();
      this.showCreatnewcountDialog = true;
      // 获取分组列表
      this.getGroupData();
      this.form = {
        mobile: "",
        qname: "",
        name: "",
        email: "",
        role: "0", // 默认角色(普通用户)
        id: "",
        pwd: "",
        confPwd: "",
        roleId:"",
      };
      this.dataoggerSwithControl = true;//默认可以添加数采器权限
      this.confpwdError = false;
      this.isError = false;
      this.emailError = false;
      this.passpwdError = false;
      this.phoneError = false;
      this.Byte = false;
      this.strength = false;
      this.usrtip = null;
      this.pwdtip = null;
      this.emailtip = null;
      this.phonetip = null;
      this.confpwdtip = null;
    },
    //创建账号
    creatnewcount () {
      this.$refs.creatForm.validate(valid => {
        if (!valid) return false;
        this.createBtnLoading = true;
        let addCollectorPermissionsVal,action,param;
        if(this.$store.state.user.role == 2&&this.form.role==2){
          addCollectorPermissionsVal = this.$store.state.user.addCollectorPermissions?true:false
        }else{
          addCollectorPermissionsVal = this.form.role==2?this.dataoggerSwithControl:""
        }
        if(this.form.role == 100||this.form.role == 200){
          action = "addRYYAdmin"
          param = {
            usr: this.form.name,
            email: this.form.email,
            mobile: this.form.mobile,
            qname: this.form.qname,
            source: 1,
            vcode: this.vcode,
            addCollectorPermissions:addCollectorPermissionsVal,
            pwd: encryption.byte2hex(
              encryption.rc4(
                encryption.sha1(this.form.pwd),
                this.$store.state.user.secret
              )
            ),
            // 增加分组 id
            id: this.form.id, // 分组(默认或所选)
            roleId: this.form.roleId,
            rid: this.form.role == 100?1:2
          }
        }else{
          action = this.form.role == 2 ? "addDist" : "addPlantOwner"
          param = {
            usr: this.form.name,
            email: this.form.email,
            mobile: this.form.mobile,
            qname: this.form.qname,
            source: 1,
            vcode: this.vcode,
            addCollectorPermissions:addCollectorPermissionsVal,
            pwd: encryption.byte2hex(
              encryption.rc4(
                encryption.sha1(this.form.pwd),
                this.$store.state.user.secret
              )
            ),
            // 增加分组 id
            id: this.form.id, // 分组(默认或所选)
            roleId: this.form.role == 2?this.form.roleId:"",
          }
        }
        this.$request
          .get(action, param)
          .then(res => {
            if (res.err == 0) {
              // this.$message.success(this.$t("account.createSuc"));
              // 通知侧栏更新账户列表
              this.showCreatnewcountDialog = false;
              this.creatAccountSucVisible = true;
              this.getAccountList();
              // 通知侧栏更新树形控件
              this.$store.state.event.sidebarmodeTree = true;
              //               if(this.groupIsShow.groupIsShow ==1)
              // this.$store.state.event.updateAccountList = true;
              // else
              // this.getAccountList();
            }else if(res.err==13){
              this.deviceTipMsg = this.$t('account.limit_UserTypeNum');
              this.creatAccountFailVisible = true;
            }else if(res.err==8){
              this.deviceTipMsg = this.$t('account.limit_UserTypeDataPermission');
              this.creatAccountFailVisible = true;
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = this.$t(`errCode.${res.err}`);
              this.creatAccountFailVisible = true;
            }
            this.createBtnLoading = false;
          });
      });
    },
    //获取经销商编码（创建经销商账号时有用）
    getVcode () {
      this.$request.get("queryAccountInfo").then(res => {
        if (res.err == 0) {
          if (res.dat.vendor) {
            this.vcode = res.dat.vendor.vcode.join(",");
          } else if (res.dat.dist) {
            this.vcode = res.dat.dist.vcode.join(",");
          }
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    getDistRoleList () {
      this.$request.get("queryDistRoleList").then(res => {
        if (res.err == 0) {
          this.DistRoleList = res.dat
        }else{
          this.DistRoleList = []
        }
      });
    },
    //打开归属业主绑定
    bandingCount (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('account_ownership')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.adminDatas.usr = ""
      this.adminDatas.pid = info.uid
      this.showBandingDialog = true
      this.loadingBelong = true
      this.$request.get("webQueryAccountsNoPaging", { role: 2 }).then((res) => {
        if (res.err == 0) {
          this.adminData = res.dat.account
        } else {
          this.adminData = []
        }
        this.loadingBelong = false
      })
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile (event) {
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
      });
      // this.$refs.upload.clearFiles()
      // let file = event.target.files[0];
      // if (file.size > 8 * 1024 * 1024) {
      //   this.$message.error(this.$t("createPlant.fileExceed"));
      //   return;
      // }
      this.distributionFile = event.target.files[0];
      // let suffix = this.distributionFile.name.split(".").slice(-1)[0];
      // if (suffix !== "xlsx" && suffix !== "xls") {
      //   this.$message.error(this.$t("account.limitFormat"));
      //   return;
      // }
    },
    // 点击切换分配方式，清除验证
    clearValidationVal () {
      this.$refs.distributionRef.resetFields();
    },
    // 打开分配数采器弹框
    distributionDatalogger (info, val) {
      if(this.disPermissionsLogo&&!this.btnList.includes('assign_collector')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.params = info;
      this.showDistributionDialog = true;
      this.distributionForm.usr = info.usr
      this.distributionForm.type = val ? this.distributionForm.type : 0
      this.distributionFile = ""
      this.$refs.distributionRef.resetFields();
    },
    distributionSub () {
      this.$refs.distributionRef.validate(valid => {
        if (!valid) return false;
        if (this.distributionForm.type == 0) {
          let param = {
            action: 'vendorAddCollector2DistByExcel',
            did: this.params.uid,
          }
          this.$request.uploadCollector(this.distributionFile, param).then(res => {
            //  console.log(res,"resresresres")
            if (res.err) {
              this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
              this.dataloggerDistributionFailVisible = true;
              this.showDistributionDialog = false;
              return;
            } else {
              if (res.dat) {
                let params = {
                  action: "downLoadFile",
                  id: res.dat,
                  i18n: this.$lang.currentLang,
                }
                window.location.href = this.$request.http_download_url_new(params)
                setTimeout(() => { this.$message.success(this.$t("report.download")) }, 2000)
              }else{
                this.dataloggerDistributionSucVisible = true;
              }
              this.showDistributionDialog = false;
            }
          });
        } else if (this.distributionForm.type == 1) {
          let param = {
            action: 'vendorAddCollector2DistByPn',
            did: this.params.uid,
            pn: this.distributionForm.pn
          }
          this.$request.get("vendorAddCollector2DistByPn", param).then(res => {
            if (res.err) {
              this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
              this.dataloggerDistributionFailVisible = true;
            } else {
              this.dataloggerDistributionSucVisible = true;

            }
            this.showDistributionDialog = false;
          });
        } else {
          let param={
            order: this.distributionForm.order,
          }
          this.$request.get("queryCollectorCountByOMSOrder",param).then(res=>{
            if (res.err==0) {
              this.dataloggerNumbor=res.dat
              this.dataloggerOrderCheckVisible = true
            }else{
              this.$message.error(this.$t("account.Ple_orderNum1"));
            }
          })
        }
      });
    },
    // 订单分配确认弹框
    submitOrderCheck () {
      let param = {
        action: 'vendorAddCollector2DistByOMSOrder',
        did: this.params.uid,
        order: this.distributionForm.order
      }
      this.$request.get("vendorAddCollector2DistByOMSOrder", param).then(res => {
        if (res.err==0) {
          this.dataloggerDistributionSucVisible = true;
        } else if(res.err==772){
          this.OrderNumbor=res.dat
          this.dataloggerTipMsg = this.$t("account.err_orderNum")+ this.OrderNumbor +this.$t("account.err_orderNum1");
          this.dataloggerDistributionFailVisible = true;
        }else {
          this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
          this.dataloggerDistributionFailVisible = true;
        }
        this.showDistributionDialog = false;
        this.dataloggerOrderCheckVisible = false;
      });
    },
    //打开编辑用户按钮
    editcount (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('edit_account')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.showEditcountDialog = true;
      this.params = info;
      this.$refs.editForm.resetFields();
      // this.loadingeditcount = true;
      this.usrDatas = {...info}
      console.log(this.usrDatas,"this.usrDatas")
      this.dataoggerSwithControl = info.addCollectorPermissions
      // this.$request.get("webQueryUsrEs", { uid: this.params.uid }).then(res => {
      //   if (res.err == 0) {
      //     (res.dat.account[0].role =
      //       res.dat.account[0].role == "2"
      //         ? this.$t("account.distributor")
      //         : this.$t("account.plantOwner")),
      //       (this.usrDatas = res.dat.account[0]);
      //       this.dataoggerSwithControl = res.dat.account[0].addCollectorPermissions
      //   } else {
      //     this.$message.error(this.$t(`errCode.${res.err}`));
      //   }
      //   this.loadingeditcount = false;
      // });
    },
    //归属业主用户
    bangdingoldcount () {
      if (this.adminDatas.usr) {
        let param = {
          pid: this.adminDatas.usr,
          uid: this.adminDatas.pid,
        }
        this.$request.get("webTransferAccountToDist", param).then((res) => {
          if (res.err == 0) {
            this.showEditcountDialog = false;
            this.bandingAccountSucVisible = true;
          } else {
            this.deviceTipMsg = this.$t(`errCode.${res.err}`);
            this.bandingAccountFailVisible = true;
          }
        })
        this.showBandingDialog = false;
      } else {
        this.$message.error(this.$t("account.adminRelated"))
      }
    },
    //编辑用户
    editoldcount () {
      this.$refs.editForm.validate(valid => {
        if (!valid) return false;
        let addCollectorPermissionsVal;
        if(this.$store.state.user.role == 2&&this.params.roleType==2){
          addCollectorPermissionsVal = this.$store.state.user.addCollectorPermissions?true:false
        }else{
          addCollectorPermissionsVal = this.params.roleType==2?this.dataoggerSwithControl:""
        }
        this.$request
          .get("editSubAccount", {
            uid: this.params.uid,
            addCollectorPermissions: addCollectorPermissionsVal,
            qname: this.usrDatas.qname || ' ',
            mobile: this.usrDatas.mobile,
            email: this.usrDatas.email,
            roleId: (this.$store.state.user.role == 1&&this.params.roleType==2)?this.usrDatas.roleId:"",
          })
          .then(res => {
            if (res.err == 0) {
              // this.$message.success(this.$t("account.modifiedsuccess"));
              this.showEditcountDialog = false;
              this.editAccountSucVisible = true;
              this.getAccountList();
            }else if(res.err==8){
              this.deviceTipMsg = this.$t('account.limit_UserTypeDataPermission');
              this.editAccountFailVisible = true;
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = this.$t(`errCode.${res.err}`);
              this.editAccountFailVisible = true;
            }
          });
      });
    },
    //打开禁用按钮
    disablecount (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('disable')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      // console.log("禁用/启用=>info", info);
      this.showdisablecountDialog = true;
      this.params = info;
      // console.log("account-禁用/启用=>this.params", this.params);
    },
    //禁用账号
    disableoldcount () {
      this.$request
        .get("disableOrEnableAccount", {
          enable:this.params.enable.class == "inactivedis"? "true": "false",
          uid: this.params.uid
        })
        .then(res => {
          if (res.err == 0) {
            if (this.params.enable.class == "inactivedis") {
              // this.$message.success(this.$t("account.enablesuccess"));
              this.deviceTipMsg = this.$t("account.enablesuccess");
            } else {
              // this.$message.success(this.$t("account.disablesuccess"));
              this.deviceTipMsg = this.$t("account.disablesuccess");
            }
            this.disableAccountSucVisible = true;
            this.showdisablecountDialog = false;
            this.getAccountList();
            // 更新store(因是点击切换不易通知更新故用this.usrDatas赋值)
            // this.$store.commit("saveAccountInfo", {
            //   enableNew: !this.params.enableNew, // 禁用启用(取反)
            // });
          } else {
            // this.$message.error(this.$t(`errCode.${res.err}`));
            this.deviceTipMsg = this.$t(`errCode.${res.err}`);
            this.disableAccountFailVisible = true;
          }
        });
    },
    //打开分组按钮
    groupcount (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('group')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.params = info;
      this.groupcountcontent.usr = info.usr;
      this.groupcountcontent.id = info.groupId;
      this.removeGroudID = info.groupId;
      this.midgroup = [];

      this.loadingGroup = true;
      this.$request.getDEVMicroservices("/ppr/web/iotSysUserGroup/auth/getList").then(res => {
        if (res.code === 0) {
          this.showGroupcountDialog = true;
          res.data.forEach(item => {
            this.midgroup.push({
              label: item.groupName,
              value: item.id
            });
          });
          let arr = { label: this.$t("account.deletegroup"), value: "0.0001" };
          this.midgroup.unshift(arr);
          this.groupList = this.midgroup;

          this.loadingGroup = false;
        }else{
          this.loadingGroup = false;
          this.$message.error(this.$t(`errCode.${res.err}`))
        }
      });
    },
    //向分组中加成员按钮
    addgroupcount () {
      this.$refs.groupform.validate(valid => {
        if (!valid) return false;
        if (this.groupcountcontent.id == "0.0001") {
          this.$request
            .postDEVMicroservices("/ppr/web/iotSysUserGroup/auth/removeUsers", {
              groupId: this.removeGroudID,
              userIds: [this.params.uid]
            })
            .then(res => {
              if (res.code == 0) {
                // this.$message.success(this.$t("account.deletegroupsuccess"));
                this.deviceTipMsg = this.$t("account.deletegroupsuccess");
                this.editToGroupSucVisible = true;
                this.showGroupcountDialog = false;
                // 通知侧栏更新账户列表
                if (this.groupIsShow.groupIsShow == 1)
                  this.$store.state.event.updateAccountList = true;
                else
                  this.getAccountList();
              } else {
                // this.$message.error(this.$t(`errCode.${res.err}`));
                this.deviceTipMsg = res.message || this.$t(`errCode.${res.err}`);
                this.editToGroupFailVisible = true;
              }
            });
        } else {
          this.$request
            .postDEVMicroservices("/ppr/web/iotSysUserGroup/auth/moveUsers", {
              groupId: this.groupcountcontent.id,
              userIds: [this.params.uid]
            })
            .then(res => {
              if (res.code == 0) {
                // this.$message.success(this.$t("account.groupsuccess"));
                this.deviceTipMsg = this.$t("account.groupsuccess");
                this.editToGroupSucVisible = true;
                this.showGroupcountDialog = false;
                // 通知侧栏更新账户列表
                // if (this.groupIsShow.groupIsShow == 1)
                //   this.$store.state.event.updateAccountList = true;
                // else
                  this.getAccountList();
              } else {
                // this.$message.error(this.$t(`errCode.${res.err}`));
                this.deviceTipMsg = this.$t(`errCode.${res.err}`);
                this.editToGroupFailVisible = true;
              }
            });
        }
      });
    },
    //打开重置密码按钮
    resetpwd (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('reset_password')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.showResetpwdDialog = true;
      this.params = info;
      this.resetform.usr = info.usr;
      this.resetform.newpwd = null;
      this.resetform.confPwd = null;

      this.confpwdError = false;
      this.isError = false;
      this.emailError = false;
      this.passpwdError = false;
      this.phoneError = false;
      this.Byte = false;
      this.strength = false;
      this.usrtip = null;
      this.pwdtip = null;
      this.emailtip = null;
      this.phonetip = null;
      this.confpwdtip = null;

      // this.$nextTick(()=> {
      //   this.$refs.resetform.resetFields();
      // });
    },
    //重置密码
    resetpwdold () {
      // console.log("[cookie-secret]", cookie.getCookie("secret"));
      this.$refs.resetform.validate(valid => {
        if (!valid) return false;
        this.$request
          .get("resetSubUsrPassword", {
            uid: this.params.uid,
            newpwd: encryption.byte2hex(
              encryption.rc4(
                encryption.sha1(this.resetform.newpwd),
                this.$store.state.user.secret,
                // cookie.getCookie("secret")
              )
            )
          })
          .then(res => {
            if (res.err == 0) {
              // this.$message.success(this.$t("account.pwdresetsuccess"));
              this.resetPwdSucVisible = true;
              this.showResetpwdDialog = false;
              this.getAccountList();
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = this.$t(`errCode.${res.err}`);
              this.resetPwdFailVisible = true;
              this.showResetpwdDialog = false;
            }
          });
      });
    },
    //打开删除按钮
    detelegroup (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('delete_account')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.showDeletecountDialog = true;
      this.params = info;
    },
    //删除用户按钮
    deleteoldcount () {
      // console.log("del-submit-this.params", this.params);
      //删除经销商账号
      this.deleteBtnLoading = true;
      if (this.params.role == this.$t("account.distributor")) {
        this.$request
          .get("delDist", {
            uid: this.params.uid
          })
          .then(res => {
            if (res.err == 0) {
              // this.$message.success(this.$t("account.Deletesuccessfully"));
              // 通知侧栏更新树形控件
              this.$store.state.event.sidebarmodeTree = true;
              // 通知侧栏更新账户列表
              this.showDeletecountDialog = false;
              this.delAccountSucVisible = true;
              // this.$store.state.event.updateAccountList = true;
              this.getAccountList();
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = this.$t(`errCode.${res.err}`);
              this.delAccountFailVisible = true;
            }
             this.deleteBtnLoading = false;
          });
      } //删除电站业主账号
      else if (this.params.role == this.$t("account.plantOwner")) {
        this.$request
          .get("delPlantOwner", {
            uid: this.params.uid
          })
          .then(res => {
            if (res.err == 0) {
              // this.$message.success(this.$t("account.Deletesuccessfully"));
              // 通知侧栏更新树形控件
              this.$store.state.event.sidebarmodeTree = true;
              // 通知侧栏更新账户列表
              this.showDeletecountDialog = false;
              this.delAccountSucVisible = true;
              // this.$store.state.event.updateAccountList = true;
              this.getAccountList();
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = this.$t(`errCode.${res.err}`);
              this.delAccountFailVisible = true;
            }
               this.deleteBtnLoading = false;
          });
      }
    },
    // 点击用户名打开该用户窗口
    // enterAccount(info) {
    //   // 非储能用户不能跳转
    //   if (info.source != 1) {
    //     this.$message.error(this.$t("usertable.cannotRedirect"));
    //     return;
    //   }
    //   this.$request
    //     .get("applyBrowsePermission", { uid: info.uid })
    //     .then(res => {
    //       if (res.err === 0) {

    //         console.log("enterAccount->res.dat", res.dat);
    //         // 辅助字段用户用于控制某些操作按钮显隐
    //         // this.$store.commit("saveAccountInfo", {
    //         //   uidExtra: info.uid, 
    //         // });

    //         let routeUrl = this.$router.resolve({
    //           path: "/home",
    //           query: {
    //             secret: res.dat.secret,
    //             token: res.dat.token,
    //             role: res.dat.role,
    //             pprAuth: res.dat.pprAuth,
    //             // 增加辅助字段
    //             // uidExtra: info.uid,
    //           }
    //         });
    //         window.open(routeUrl.href, "_blank");
    //       } else {
    //         this.$message.error(this.$t(`errCode.${res.err}`));
    //       }
    //     });
    // },
    // 点击跳转改为点击展示详情页(含返回与跳转)
    enterAccount (info) {
      console.log(info,"infoinfo")
      // 清除当前选中分组ID
      // this.$store.commit('saveGroupIdClick', {
      //   groupIdClick: ''
      // });

      // console.log("show=>singleBox(account)");
      // this.curAccount = info.usr;
      // console.log("enterAccount=>info", info);
      this.$store.commit("saveAccountInfo", {
        collectorsNew: info.collectors || '0', //
        devicesNew: info.devices || '0', //
        avatarNew: info.avatar, // 用户头像[重命名][缺]
        qnameNew: info.qname, // 用户昵称
        usrNew: info.usr || '--', // 账号名称
        enableNew: info.enable || '--', // 是否禁用
        activeNew: info.active || '--', // 活跃度
        roleNew: info.role || '--', // 用户角色[重命名]
        // role: info.role || '--', // 用户角色[重命名]
        mobileNew: info.mobile || '--', // 电话
        emailNew: info.email || '--', // 邮箱
        groupNew: info.group || '--', // 分组
        createTimeNew: info.gts || '--', // 创建时间
        lastLoginTsNew: info.lastLoginTs || '--', // 最后登录时间
        sourceNew: info.source || '--', // 用于判断是否储能用户
        uidNew: info.uid || '--', //
        addCollectorPermissions: info.addCollectorPermissions==false?false:true,  //是否有新增数采器权限
        rolePermissionId: info.roleId, //厂家创建经销商账号选择的角色权限ID
        riyueyuanUserTypeRid: info.rid //日月元新增用户类型标识

        // collectors: info.collectors, //
        // devices: info.devices, // 设备
        // groupId: info.groupId, // 分组ID
        // gts: info.gts, //
        // rid: info.rid, // 
      });
      // 通知显示账号信息页(隐藏table)
      this.$emit('noticeDeviceBox', false);
      this.$store.commit("saveGroupIdClick", {
        groupIdClick: "",
        groupNameClick: ""
      });
    },
    // 关于搜索弹窗 =====
    // 关闭搜索框
    closeSearch () {
      this.showSearch = false;
      this.search.role = null;
      this.search.active = null;
      this.search.enable = null;
      this.search.groupid = null;
      this.search.usr = null;
      this.getAccountList();
    },
    showSearchBtn () {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      })
    },
  }
};
</script>
<style lang="less" scoped>
.accountNew {
  background-color: #fff;
  // margin: 20px;
  display: flex;
  flex-direction: column;
  border-radius: 0px;
  .help-label {
        font-size: 12px;
        color: rgba(235, 235, 235, 0.8);
        margin-left: 20px;
        display: inline-block;
      }
        //开关按钮
        .eb-switch {

&.el-switch {

  // 轨道
  /deep/.el-switch__core {
    position: relative;
    vertical-align: middle;
    margin: 0;
    display: inline-block;
    width: 40px;
    height: 20px;
    outline: 0;
    border-radius: 10px;
    box-sizing: border-box;
    background-color: #222D35;
    border: 1px solid #707973;
    cursor: pointer;
    transition: border-color .3s, background-color .3s;

    // transition: unset;
    // 开关把手
    &:after {
      content: "";
      width: 12px;
      height: 12px;
      top: 3px;
      left: 3px;
      box-sizing: border-box;
      background-color: #222D35;
      border: 1px solid #ADB9C0;
      border-radius: 100%;
    }
  }
}

// 激活(true)
&.el-switch.is-checked {

  // 轨道
  /deep/.el-switch__core {
    background-color: @primaryTextColor;
    border: 1px solid @primaryTextColor;

    // 开关把手
    &:after {
      content: "";
      left: 100%;
      margin-left: -16px;
      background-color: rgba(255, 255, 255, 1);
      border: 1px solid rgba(255, 255, 255, 1);
    }
  }
}
}

  //固定列遮挡最后一列边框
  /deep/ .el-table__row {
    td:not(.is-hidden):last-child {
      right: -6px;
    }
  }

  /deep/ .el-table__header {
    th:not(.is-hidden):last-child {
      right: -6px;
    }
  }

  .upload-input {
    display: none;
  }

  // 上传固件弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }
  }

  .grid {
    grid-row-gap: 20px;
    padding-bottom: 0px;
  }

  // 统一按钮
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  // 加载动画
  &.tableloding {

    // 遮罩
    /deep/.el-loading-mask {
      background-color: rgb(34, 45, 53, .5);
    }

    // 花形
    /deep/.el-loading-spinner i {
      color: @primaryTextColor;
    }

    // 环形
    /deep/.el-loading-spinner .path {
      stroke: @primaryTextColor;
    }
  }

  // 可点击跳转的标题
  .redirect {
    color: @primaryTextColor;
  }

  /deep/.el-form-item__label {
    color: rgba(255, 255, 255, 1);
  }

  .chuangjian,
  .chongzhi {
    .juxing {
      display: inline-block;
      width: 100px;
      height: 10px;
      border: 0px solid #fff;
      margin-left: 5px;
    }

    .inputlo {
      margin-bottom: -16px;
      min-height: 20px;
      width: 100%;
    }

    .input_spans,
    .pwd_span,
    .email_span,
    .phone_span,
    .confpwd_span {
      min-height: 20px;
      line-height: 20px;
      color: #f56c6c;
      font-size: 12px;
      word-wrap: break-word;
      word-break: break-all;
      white-space: normal;
    }

    .input_span {
      min-height: 20px;
      line-height: 20px;
      word-wrap: break-word;
      word-break: break-all;
      white-space: normal;
    }

    .sucess {
      min-height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: #999;
      word-wrap: break-word;
      word-break: break-all;
      white-space: normal;
      // font-family: "Microsoft YaHei";
    }

    /deep/ .el-form-item__error {
      display: none;
    }
  }

  .button-create {
    float: right;
  }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    // overflow: auto;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        width: 105px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .search-alert {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .searchDiv {
          position: absolute;
          top: 0;
          // left: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {

          // display: flex;
          // align-items: center;
          // justify-content: flex-end;
          /deep/.el-input__inner {
            width: 220px;
            padding-left: 10px;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #33FFB6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #7B8395;
          border-left: 1px solid #7B8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7B8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202D35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: 0px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: 'X'
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }

      .batch-alert {
        height: 48px;
        line-height: 48px;
      }

      /deep/.el-input:not(:last-child) {
        margin-right: 0px;
      }

      /deep/.el-select:not(:last-child) {
        margin-right: 0px;
      }

      .button-upload {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 114px;
        height: 48px;
        line-height: 16px;
        background: @primaryTextColor;
        color: rgb(34, 45, 53);
        font-size: 14px;
        border-radius: 0px;
        border: none;
        cursor: pointer;
      }
    }

    .search1 {
      padding: 0 20px;
      height: 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .operation {
        color: #F3FAFE;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        padding: 0 10px;
        // width: 102px;
      }

      .search1-left {
        display: flex;
        justify-content: flex-start;

        .groupBox {
          .groupEdit {
            height: 26px;
            padding-right: 20px;
            font-size: 20px;
            color: #fff;

            /deep/.el-input__inner {
              background: #222D35;
              border: none;
              height: 26px;
              width: 120px;
              padding: 0;
              font-size: 20px;
              color: #fff;
            }
          }
        }

        .icon-bianji {
          font-size: 26px;
          color: #33FFB6;
        }
      }

    }

    .table {
      flex: 1;
      overflow: auto;

      /deep/.el-icon-loading {
        font-size: 28px;
      }
    }

    // .tablebottom {
    //   align-self: flex-end;
    //   // text-align: center;
    //   margin-bottom: 10px;
    // }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      .operation1 i {
        color: @primaryColorTransparency30;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        // border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
        z-index: 9999;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }

      // // 表格右侧固定栏
      // /deep/.el-table__fixed-right {
      //   right: 6px !important;
      // }

      // /deep/.el-table__body-wrapper.is-scrolling-none~.el-table__fixed,
      // /deep/.el-table__body-wrapper.is-scrolling-none~.el-table__fixed-right,
      // /deep/.el-table__body-wrapper.is-scrolling-right~.el-table__fixed-right {
      //   right: 6px !important;
      // }
    }

    // 关于表格右侧边线
    /deep/.el-table--border::after {
      display: none;
    }

    /deep/.el-table--group::after {
      display: none;
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2B3842;
          color: #15C491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7B8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2B3842;
        color: #7B8395;
      }
    }

    .current-value {
      display: flex;

      .el-input {
        flex: 1;
        margin-right: 3px;
      }

      .submit-control {
        i {
          font-size: 18px;
        }

        padding: 5px 12px;
      }
    }

    .control-value {
      .submit-control {
        padding: 6px 20px;

        i {
          font-size: 18px;
        }
      }
    }

    .control {
      height: 50vh;

      .el-table {
        margin-bottom: 20px;

        /deep/ tr td:first-child .cell {
          text-align: left;
        }
      }

      .tableTitle {
        margin-bottom: 5px;
        // padding: 20px 0 5px;
        font-size: 16px;
        color: #595959;
        font-weight: bold;
      }
    }
  }

  .active {
    color: #26ae3c;
  }

  // 不活跃
  .inactive {
    color: #c9c9c9;
  }

  // 禁用
  .inactivedis {
    color: rgba(255, 62, 62, 1);
  }
}

// .disablecontent {
//   display: flex;
//   justify-content: center;
//   font-size: 20px;
//   font-weight: 600;
// }
// .disabledescr {
//   display: flex;
//   justify-content: center;
//   margin-top: 10px;
//   font-size: 10px;
// }

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>
<style lang="less">
// #下拉选框 el-select#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^=top] .popper__arrow {
    display: none;
  }

  // 滚动条
  ::-webkit-scrollbar {
    // width: 0px;
    // height: 0px;
    background-color: transparent;
  }

  // 下拉框上传固件按钮
  // .upFirewareBtn {
  //   background: rgba(34, 45, 53, 1);
  //   border: 1px solid rgba(226, 227, 227, 1);
  //   border-radius: 6px;
  //   padding:6px 30px;
  //   color: rgba(226, 227, 227, 1);
  //   font-size: 14px;cursor:pointer;
  // }
}

// .select-search-project {
//   .el-select-dropdown__list {
//     padding: 0 16px;
//   }
//   .el-select-dropdown__item {
//     height: 40px;
//     line-height: 40px;
//     box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
//   }
// }
// #分页下拉框#
.select-page {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 12px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
    background-color: rgb(34, 45, 53);
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
    min-width: 110px;
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^=top] .popper__arrow {
    display: none;
  }
}

.selectClearNew {

  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}</style>
